export const contractAddress =
  'erd1qqqqqqqqqqqqqpgq72l6vl07fkn3alyfq753mcy4nakm0l72396qkcud5x';

export const dAppName = 'r3d4';

// Generate your own WalletConnect 2 ProjectId here: https://cloud.walletconnect.com/app
export const walletConnectV2ProjectId = '9b1a9564f91cb659ffe21b73d5c4e2d8';

export const apiTimeout = 6000;
export const transactionSize = 15;
export const TOOLS_API_URL = 'https://devnet-tools.multiversx.com';
export const FAUCET_API_URL = 'https://devnet-claim.dinovox.com';
// Amount handed out per claim — kept in sync manually with FAUCET_EGLD_AMOUNT on the faucet backend
export const FAUCET_AMOUNT_EGLD = '1';
// Wallet the faucet sends devnet EGLD from
export const FAUCET_WALLET_ADDRESS =
  'erd12stex47hwg0hvx8cfvukj3y3ugs7dm0686k3wasycffexva6ch9s7tvj29';
/**
 * Calls to these domains will use `nativeAuth` Baerer token
 */
export const sampleAuthenticatedDomains = [TOOLS_API_URL, FAUCET_API_URL];
